var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
// - Material UI
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SvgClose from '@material-ui/icons/Clear';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
// - Import app components
// - Import API
// - Import actions
import { globalActions } from 'store/actions';
import { Feed } from 'core/domain/common';
import { FeedType } from 'core/domain/common/feedType';
import StringAPI from 'api/StringAPI';
import { ServerRequestType } from 'constants/serverRequestType';
import { ServerRequestStatusType } from 'store/actions/serverRequestStatusType';
var styles = function (theme) {
    var _a;
    return ({
        fullPageXs: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0,
                overflowY: 'auto'
            },
            _a)
    });
};
/**
 * Create component class
 */
var SendFeedbackComponent = /** @class */ (function (_super) {
    __extends(SendFeedbackComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function SendFeedbackComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFeedText = function (event) {
            var target = event ? event.target : {};
            var value = target ? target.value : '';
            if (value) {
                _this.setState({
                    feedText: value
                });
            }
        };
        _this.handleSendFeed = function (feedType) {
            var _a = _this.props, sendFeed = _a.sendFeed, currentUser = _a.currentUser;
            var feedText = _this.state.feedText;
            sendFeed(new Feed('', feedText, feedType, currentUser));
        };
        _this.mainForm = function () {
            var _a = _this.props, sendFeedbackStatus = _a.sendFeedbackStatus, hideFeedback = _a.hideFeedback, sendFeed = _a.sendFeed, sendFeedbackRequestType = _a.sendFeedbackRequestType, translate = _a.translate;
            var feedText = _this.state.feedText;
            return (React.createElement("div", { className: 'main-box' },
                React.createElement(TextField, { placeholder: translate('feedback.textareaPlaceholder'), multiline: true, onChange: _this.handleFeedText, rows: 2, rowsMax: 4, autoFocus: true, fullWidth: true }),
                React.createElement("br", null),
                React.createElement("div", { className: 'buttons' },
                    React.createElement(Tooltip, { title: translate('feedback.sadTooltip'), placement: 'bottom-start' },
                        React.createElement(IconButton, { className: 'flaticon-sad-2 icon__svg', onClick: function () { return _this.handleSendFeed(FeedType.Sad); } })),
                    React.createElement(Tooltip, { title: translate('feedback.acceptableTooltip'), placement: 'bottom-start' },
                        React.createElement(IconButton, { className: 'flaticon-neutral icon__svg', onClick: function () { return _this.handleSendFeed(FeedType.Acceptable); } })),
                    React.createElement(Tooltip, { title: translate('feedback.happyTooltip'), placement: 'bottom-start' },
                        React.createElement(IconButton, { className: 'flaticon-happy-2 icon__svg', onClick: function () { return _this.handleSendFeed(FeedType.Happy); } })),
                    React.createElement(Tooltip, { title: translate('feedback.awesomeTooltip'), placement: 'bottom-start' },
                        React.createElement(IconButton, { className: 'flaticon-happy icon__svg', onClick: function () { return _this.handleSendFeed(FeedType.Awesome); } })))));
        };
        _this.loadingForm = function () {
            var translate = _this.props.translate;
            return (React.createElement("div", { className: 'loading' },
                React.createElement("p", null, translate('feedback.sendingMessage')),
                React.createElement("div", { className: 'icon' },
                    React.createElement(CircularProgress, { color: 'secondary', size: 50, variant: 'determinate', value: (25 - 0) / (50 - 0) * 100 }))));
        };
        _this.successForm = function () {
            var translate = _this.props.translate;
            return (React.createElement("div", { className: 'success' }, translate('feedback.appreciateMessage')));
        };
        _this.errorForm = function () {
            var translate = _this.props.translate;
            return (React.createElement("div", { className: 'error' }, translate('feedback.errorMessage')));
        };
        _this.getFeedbackForm = function () {
            var _a = _this.props, sendFeedbackStatus = _a.sendFeedbackStatus, hideFeedback = _a.hideFeedback, sendFeed = _a.sendFeed, sendFeedbackRequestType = _a.sendFeedbackRequestType;
            var feedText = _this.state.feedText;
            if (sendFeedbackRequestType) {
                switch (sendFeedbackRequestType) {
                    case ServerRequestStatusType.Sent:
                        return _this.loadingForm();
                    case ServerRequestStatusType.OK:
                        return _this.successForm();
                    case ServerRequestStatusType.Error:
                        return _this.errorForm();
                    default:
                        return _this.mainForm();
                }
            }
            else {
                return _this.mainForm();
            }
        };
        // Defaul state
        _this.state = {
            feedText: ''
        };
        // Binding functions to `this`
        _this.handleFeedText = _this.handleFeedText.bind(_this);
        _this.getFeedbackForm = _this.getFeedbackForm.bind(_this);
        _this.mainForm = _this.mainForm.bind(_this);
        _this.loadingForm = _this.loadingForm.bind(_this);
        _this.successForm = _this.successForm.bind(_this);
        _this.errorForm = _this.errorForm.bind(_this);
        return _this;
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    SendFeedbackComponent.prototype.render = function () {
        var _a = this.props, sendFeedbackStatus = _a.sendFeedbackStatus, hideFeedback = _a.hideFeedback, sendFeed = _a.sendFeed, sendFeedbackRequestType = _a.sendFeedbackRequestType, classes = _a.classes;
        var feedText = this.state.feedText;
        return (React.createElement("div", { className: classNames('sendFeedback__content', 'animate__up', classes.fullPageXs) },
            React.createElement(Paper, { className: 'paper' },
                React.createElement("div", { className: 'close' },
                    React.createElement(Tooltip, { title: 'Cancel', placement: 'bottom-start' },
                        React.createElement(IconButton, { onClick: function () { return hideFeedback(); } },
                            React.createElement(SvgClose, null)))),
                this.getFeedbackForm())));
    };
    return SendFeedbackComponent;
}(Component));
export { SendFeedbackComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        sendFeed: function (feed) { return (dispatch(globalActions.dbSendFeed(feed))); },
        hideFeedback: function () { return dispatch(globalActions.hideSendFeedback()); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var request = state.getIn(['server', 'request']);
    var uid = state.getIn(['authorize', 'uid']);
    var requestId = StringAPI.createServerRequestId(ServerRequestType.CommonSendFeedback, uid);
    var currentUser = __assign({}, state.getIn(['user', 'info', uid], {}), { userId: uid });
    var sendFeedbackStatus = state.getIn(['global', 'sendFeedbackStatus']);
    var sendFeedbackRequestType = state.getIn(['server', 'request', requestId]);
    return {
        translate: getTranslate(state.get('locale')),
        sendFeedbackStatus: sendFeedbackStatus,
        sendFeedbackRequestType: sendFeedbackRequestType ? sendFeedbackRequestType.status : ServerRequestStatusType.NoAction,
        currentUser: currentUser
    };
};
// - Connect component to redux store
//
export default connect(mapStateToProps, mapDispatchToProps)((withStyles(styles)(SendFeedbackComponent)));



//////////////////
// WEBPACK FOOTER
// ./src/components/sendFeedback/SendFeedbackComponent.tsx
// module id = 880
// module chunks = 50